import type { ReactNode } from 'react';

import { Alert, type AlertProps, Group, List, Text } from '@mantine/core';
import { ClientError } from 'graphql-request';
import { CircleAlert } from 'lucide-react';

export interface ErrorAlertProps extends Omit<AlertProps, 'color' | 'icon'> {
  action?: ReactNode;
  error: ClientError | Error;
}

export function ErrorAlert({ action, error, ...props }: ErrorAlertProps) {
  let message: ReactNode = error.message;

  if (error instanceof ClientError && error.response.errors?.length) {
    if (error.response.errors.length === 1) {
      message = error.response.errors[0].message;
    } else {
      message = (
        <List>
          {error.response.errors.map((e) => (
            <List.Item key={e.message}>
              <Text span variant="body-1">
                {e.message}
              </Text>
            </List.Item>
          ))}
        </List>
      );
    }
  }

  return (
    <Alert color="red" icon={<CircleAlert />} variant="filled" {...props}>
      <Group justify="space-between">
        {typeof message === 'string' ? <Text variant="body-1">{message}</Text> : message}
        {action}
      </Group>
    </Alert>
  );
}
